"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _WebRequestHelper = require("../../../../swcp-base/js/helpers/WebRequestHelper");
var _components = require("../../../../swcp-base/js/components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class ImprintText extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      imprintText: ""
    };
  }
  componentDidMount() {
    this.setState({
      fetching: true
    });
    (0, _WebRequestHelper.createRequest)(true).then(request => {
      request.method = "get";
      request.url = `translationentries?expand=Language&limit=50&filter=TranslationId%20!=%20null%20and%20TranslationId.Equals(%22IMPRINT_TEXT%22)`;
      return (0, _WebRequestHelper.sendRequest)(request).then(response => {
        let responseValue = "";
        if (response.data.length) responseValue = response.data[0].Value;
        this.setState({
          fetching: false,
          imprintText: responseValue
        });
      }).catch(error => {
        this.setState({
          fetching: false
        });
        console.dir(error);
      });
    }).catch(error => {
      this.setState({
        fetching: false
      });
      console.dir(error);
    });
  }
  render() {
    const {
      fetching,
      imprintText
    } = this.state;
    if (fetching) return /*#__PURE__*/_react.default.createElement(_components.Spinner, null);else if (imprintText) {
      return /*#__PURE__*/_react.default.createElement("div", null, (0, _htmlReactParser.default)(imprintText));
    } else {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "alert alert-danger",
        role: "alert"
      }, "Not provided yet.");
    }
  }
}
var _default = exports.default = ImprintText;
module.exports = exports.default;